import { useEffect } from "react";
/**
 * Mostly für Filtervergabe, da für fast alle Layer ein Base-Level-Filter gilt!
 */
export default function Filters(props) {
    // ---- functions ----
    const filterLayers = () => {
        props.cuMap.setLevel(props.level);
    };
    const setBuildings = () => {
        if (props.buildingMarker !== true) {
            const showBuildings = props.buildings != null ? props.buildings : true;
            const buildingLabels = props.buildingLabels != null ? props.buildingLabels : true;
            props.cuMap.showBuildings = showBuildings;
            props.cuMap.showBuildingLabels = buildingLabels;
        }
    };
    // const setBuildingMarker = () => {
    //   console.log("Hello there, im in setBuildingMarker!");
    // };
    const setRoomLabels = () => {
        var _a, _b;
        const minZoomRoomLabels = (_a = props.minZoomRoomLabels) !== null && _a !== void 0 ? _a : 18;
        const roomLabels = (_b = props.roomLabels) !== null && _b !== void 0 ? _b : false;
        props.cuMap.setRoomZoomLevel(minZoomRoomLabels);
        props.cuMap.showRoomLabels = roomLabels;
    };
    // const hideOsmBuildings = () => {
    //   if (props.hideOsmBuildings === false) return;
    //   // TODO: Badly implemented OSM building features
    //   // Those are MapTiler layers, and those are OpenStreetTile Ids of some buildings which should not be shown.
    //   const badBuildingLayers = ["building", "building-top", "building-3d"];
    //   badBuildingLayers.forEach((layer) => {
    //     props.cuMap.setFilter(layer, [
    //       "!",
    //       [
    //         "any",
    //         // Frankfurt:
    //         ["==", ["id"], 1358494],
    //         ["==", ["id"], 473368900],
    //         ["==", ["id"], 598973453],
    //         ["==", ["id"], 1358493],
    //         // HDZ:
    //         ["==", ["id"], 166981],
    //         ["==", ["id"], 137188451],
    //         ["==", ["id"], 374924236],
    //         ["==", ["id"], 374924808],
    //         ["==", ["id"], 137188457],
    //         ["==", ["id"], 37263641],
    //         ["==", ["id"], 374924809],
    //         ["==", ["id"], 466723620],
    //         ["==", ["id"], 374924235],
    //         ["==", ["id"], 37263643],
    //         ["==", ["id"], 37263642],
    //         ["==", ["id"], 37263645],
    //         ["==", ["id"], 37263644],
    //       ],
    //     ]);
    //   });
    // };
    const hideOsmIds = () => {
        if (props.badOsmIds == null || props.badOsmIds.length === 0)
            return;
        const result = props.badOsmIds.map((element) => {
            return ["==", ["id"], element];
        });
        // Those are MapTiler layers, and those are OpenStreetTile Ids of some buildings which should not be shown.
        const badBuildingLayers = ["building", "building-top", "building-3d"];
        badBuildingLayers.forEach((layer) => {
            props.cuMap.setFilter(layer, [
                "!",
                [
                    "any",
                    // Frankfurt:
                    ...result,
                ],
            ]);
        });
    };
    // ---- effects ----
    useEffect(filterLayers, [props.level]);
    useEffect(setBuildings, [props.buildings, props.buildingLabels]);
    // useEffect(setBuildingMarker, [props.buildings, props.buildingMarker]);
    useEffect(setRoomLabels, [props.roomLabels, props.minZoomRoomLabels]);
    // useEffect(hideOsmBuildings, [props.hideOsmBuildings]);
    useEffect(hideOsmIds, [props.badOsmIds]);
    return null;
}
